// @flow
import { createContext } from 'react';

export type departureCitiesContextType = {
  departureCities: Array<{
    label: string,
    value: string,
  }>,
  setDepartureCities: (*) => void,
};

export default createContext<departureCitiesContextType>({
  departureCities: [],
  setDepartureCities: () => {},
});
